import React from 'react';
import VehicleEntityGridPage from './VehicleEntityGridPage';
import { VEHICLE_INSURANCE } from './vehicleEntityConfigs';

const VehicleInsurance = () => <VehicleEntityGridPage config={VEHICLE_INSURANCE} />;

export default VehicleInsurance;
